import React from 'react';
import { Card } from 'react-bootstrap';
import CronJobsList from '../components/cronJobs/CronJobsList';
import InternalPage from './InternalPage';
import { useGetAllCronJobsQuery } from '../store/api/cronJobsApi';

const CronJobsPage = () => {

    const { data, isError, isFetching } = useGetAllCronJobsQuery(undefined, {
        refetchOnMountOrArgChange: true,
    });

    return (
        <InternalPage>
            <div className='title-block' style={{ backgroundImage: 'url(/static/img/title-bg-1.png)' }}>
                <h1>
                    Cron Jobs
                </h1>
            </div>

            <div className='main-content'>
                <Card className='w-100 p-3'>
                    {isFetching && <div>Loading...</div>}
                    {!isFetching && isError && <div>Oops. Somethins goes wrong.</div>}
                    {data && !isFetching && !isError && <CronJobsList cronJobs={data} />}
                </Card>
            </div>
        </InternalPage>
    );
};

export default CronJobsPage;
